import { useMemo } from "react";
import { useGetAllScreeningPreview } from "@/queries/encounter/screening/use-get-all-screening-preview";
import { DEF_PAGINATION, getXtenantId } from "@/utils/utils";
import { NotePreviewScreeningResult } from "../note-preview-types";
import { normaliseScreenerKey } from "../note-preview-screening-utils";

export interface UseScreeningResults {
  results: Record<string, NotePreviewScreeningResult>;
  isLoading: boolean;
}

interface ScreeningPreviewRow {
  score?: number | string | null;
  severity?: string | null;
  createdAt?: string | null;
}

/** Completed screeners for the appointment, keyed by normalised type, so the report can print score, severity and date as the note screen does. */
export const useScreeningResults = (
  appointmentId: string | undefined,
  enabled: boolean
): UseScreeningResults => {
  const { data, isFetching } = useGetAllScreeningPreview({
    pagination: DEF_PAGINATION,
    gridSorting: [],
    appointmentUuid: enabled && appointmentId ? appointmentId : "",
    xTENANTID: getXtenantId(),
  });

  const results = useMemo(() => {
    const rows = (data?.data ?? {}) as Record<string, ScreeningPreviewRow>;
    return Object.fromEntries(
      Object.entries(rows).map(([type, row]) => [
        normaliseScreenerKey(type),
        {
          score:
            row?.score === null || row?.score === undefined
              ? ""
              : String(row.score),
          severity: row?.severity ?? "",
          createdAt: row?.createdAt ?? "",
        },
      ])
    );
  }, [data]);

  return useMemo(
    () => ({ results, isLoading: enabled && isFetching }),
    [results, enabled, isFetching]
  );
};
